import React, { useState, useEffect } from 'react';
import { Eye, Glasses, Sun, Wrench, Contact, Heart } from 'lucide-react';
import { services as mockServices } from '../mock';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Link } from 'react-router-dom';

const BACKEND_URL = '';

const iconMap = {
  Eye: Eye,
  Glasses: Glasses,
  Sun: Sun,
  Wrench: Wrench,
  Contact: Contact,
  Heart: Heart
};

const Services = () => {
  const [services, setServices] = useState(mockServices);

  useEffect(() => {
    // Fetch services from database
    const fetchServices = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/services`);
        if (response.ok) {
          const data = await response.json();
          setServices(data);
        }
      } catch (error) {
        console.error('Error fetching services:', error);
      }
    };
    fetchServices();
  }, []);

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Eye Care Services
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Comprehensive eye care solutions tailored to your needs
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const Icon = iconMap[service.icon];
            const serviceSlug = service.title.toLowerCase().replace(/\s+/g, '-').replace(/'/g, '');
            
            return (
              <Link 
                key={service.id} 
                to={`/services/${serviceSlug}`}
                className="block"
              >
                <Card 
                  className="group hover:shadow-xl transition-all duration-300 cursor-pointer border-0 bg-white overflow-hidden h-full"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      onError={(e) => {
                        e.target.src = 'https://images.unsplash.com/photo-1574258495973-f010dfbb5371?w=800&q=80';
                      }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                    <div className="absolute bottom-4 left-4">
                      <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center">
                        {Icon && <Icon className="w-6 h-6 text-white" />}
                      </div>
                    </div>
                  </div>
                  <CardHeader>
                    <CardTitle className="text-xl group-hover:text-red-600 transition-colors">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-gray-600">
                      {service.description}
                    </CardDescription>
                    <span className="mt-4 text-red-600 font-medium hover:underline inline-block">
                      Learn More →
                    </span>
                  </CardContent>
                </Card>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
